export const status = (state) => state.status

export const getOrders = (state) => state.orders

